import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import CookieIcon from '../icons/CookieIcon';
import ZaraButton from '../buttons/Button';

const DesktopBlank = ({ acceptCookies, openNewTab }) => {
    return (
        <Flex
            css={{
                '@media only screen and (min-width: 500px)': {
                    display: 'flex',
                },
                '@media only screen and (max-width: 450px)': {
                    display: 'none',
                },
            }}
            className='cookie'
            p='20px 40px'
            alignItems='center'
            h='100px'
            bg='#858585'
            w='100%'
            pos='absolute'
            bottom='0px'
            zIndex={30}
        >
            <Flex w='100%' alignItems='center'>
                <Flex
                    mr='20px'
                    justifyContent='center'
                    alignItems='center'
                    h='42px'
                    w='42px'
                    borderRadius='12px'
                    p='10px'
                    bg='white'
                >
                    <CookieIcon />
                </Flex>
                <Box
                    color='white'
                    fontSize='16px'
                    fontWeight='400'
                    lineHeight='20px'
                    letterSpacing='0em'
                    textAlign='left'
                >
                    <Text>
                        <Text display='inline' fontWeight='700'>
                            We use cookies{' '}
                        </Text>
                        to customize to your needs and enhance your experience. Cookies are only used to help provide
                        services and can be refused by changing your browser settings.
                    </Text>
                    <Text>
                        By continuing to use the service, you agree to our use of cookies as described in{' '}
                        <Text display='inline' textDecoration='underline' cursor='pointer' onClick={openNewTab}>
                            the Cookie Policy.
                        </Text>
                    </Text>
                </Box>
                <Flex ml='20px' w='204px'>
                    <ZaraButton
                        onClick={acceptCookies}
                        variant='successOutline'
                        border='none'
                        color='#5611F8'
                        _hover={{ bg: 'white', textDecoration: 'underline' }}
                        _active={{ bg: 'white' }}
                    >
                        Agree
                    </ZaraButton>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default DesktopBlank;
